<script lang="ts">
	// Stores
	import { user_data } from 'src/stores/account/user';
	// Helpers
	import { is_notification_action_ui } from 'src/types/NotificationActionUI';
	import { is_device_action_ui } from 'src/types/DeviceActionUI';
	import { is_enable_disable_scene_action_ui, is_play_scene_action_ui } from 'src/types/SceneActionUI';
	import { format } from 'src/services/i18n';
	import { is_group_action_ui } from 'src/types/GroupActionUI';
	// Components
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import { deepCopy } from 'src/helpers/utilities';
	import {
		DO_WIZARD_STEPS_INDEXES,
		getDoTranslationType,
		getDefaultSceneData,
	} from '../helpers/do-wizard-helpers';
	import { scenes } from 'src/stores/lists/scenes';

	import { isDevServerUser, isT1User } from 'src/helpers/user_server_conditions';

	export let sceneData: any;

	const select_card_action_options = (userPremium = 0, isDevServerUser = false) => {
		//here will come check if we have premium actions options
		return [
			{
				selected: false,
				id: 1,
				title: 'device_action',
				name: $format('device_action'),
				disabled: false,
				variant: 'radio',
				icon: 'fal fa-microchip-ai',
			},
			{
				selected: false,
				id: 2,
				title: 'notify_action',
				name: $format('notify_action'),
				disabled: false,
				variant: 'radio',
				icon: 'far fa-bells',
			},
			{
				selected: false,
				id: 3,
				title: 'group_action',
				name: $format('group_action'),
				disabled: false,
				variant: 'radio',
				icon: 'far fa-object-group',
			},
			{
				selected: false,
				id: 4,
				title: 'scene_action',
				name: $format('scene_action'),
				disabled: false,
				variant: 'radio',
				icon: 'fas fa-film',
			},
			{
				selected: false,
				id: 5,
				title: 'alarm_action',
				name: $format('alarm_action'),
				disabled: false,
				variant: 'radio',
				icon: 'fas fa-siren-on',
			},
		];
	};

	let selectCards = select_card_action_options(
		$user_data.premium,
		isDevServerUser(['repo', 'nb']) || isT1User(),
	);

	const onSelectCard = (array, i: number, multipleSelect = false) => {
		array = array.map((sc) => {
			if (sc.id === i) {
				return {
					...sc,
					selected: multipleSelect ? !sc.selected : true,
				};
			}
			return {
				...sc,
				selected: multipleSelect ? sc.selected : false,
			};
		});

		return array;
	};

	const validateCondtitionSelect = (action) => {
		const { isValid, actionType } = getDoTranslationType(action, sceneData);

		// Reset scene data if no translation
		if (sceneData.selectedAction !== action && action !== actionType) {
			sceneData = deepCopy({
				...sceneData,
				...getDefaultSceneData(),
			});
		}
		sceneData.isValid = isValid;
		sceneData.validStepIndex = DO_WIZARD_STEPS_INDEXES.ACTION_STEP;
	};

	if (sceneData.translated && sceneData.validStepIndex === 0) {
		sceneData.isValid = true;
	}

	if (is_device_action_ui(sceneData.translated)) {
		sceneData.selectedAction =
			selectCards.find((el) => el.title === 'device_action')?.id || undefined;
	} else if (is_notification_action_ui(sceneData.translated)) {
		sceneData.selectedAction =
			selectCards.find((el) => el.title === 'notify_action')?.id || undefined;
	} else if (
		is_play_scene_action_ui(sceneData.translated) ||
		is_enable_disable_scene_action_ui(sceneData.translated)
	) {
		const action_type =
			$scenes[sceneData.translated.scene_id]?._gui_function &&
			$scenes[sceneData.translated.scene_id]?._gui_function === 'alarm'
				? 'alarm_action'
				: 'scene_action';

		sceneData.selectedAction = selectCards.find((el) => el.title === action_type)?.id || undefined;
	} else if (is_group_action_ui(sceneData.translated)) {
		sceneData.selectedAction =
			selectCards.find((el) => el.title === 'group_action')?.id || undefined;
	} else {
		// selectedItem = undefined;
		//by default on add action select device action
		sceneData.selectedAction = 1;
	}

	if (typeof sceneData.selectedAction !== 'undefined') {
		selectCards = onSelectCard(selectCards, sceneData.selectedAction);
	}
</script>

<SelectList
	class="mb-s"
	title={$format('select_action', { default: 'Select action' })}
	list={selectCards}
	variant="radio"
	withSearch={false}
	on:click={(e) => {
		validateCondtitionSelect(e.detail.id);
		sceneData.selectedAction = e.detail.id;
		selectCards = onSelectCard(selectCards, e.detail.id);
	}}
/>
